<template>
	<div v-wechat-title="this.catename">
		<Header>
			<div class="leftcss"><a @click='goBack'><i class="iconfont icon---"></i></a></div>
			<div class="centercss">{{catename}}</div>
			<div class="crightcss"><span id="show-modal" @click="showModal = true"><i class="iconfont icon-zhedie1"></i></span>
				<modal v-if="showModal" @close="showModal = false"> </modal>
			</div>
		</Header>
		<div class="body-main" v-if="this.$route.params.id==='1'">
                <router-link to="/c8"><h1  class="martop">洞真上清经</h1></router-link>
					 <ul><li v-for="item in listarr8" class="cateli"><router-link :to="'/daozang8'+'-'+item.id">{{item.title}}</router-link></li></ul>
			    </br>
				<router-link to="/c9"><h1  class="martop">洞玄灵宝经</h1></router-link>
					 <ul><li v-for="item in listarr9" class="cateli"><router-link :to="'/daozang9'+'-'+item.id">{{item.title}}</router-link></li></ul>
				</br>
				<router-link to="/c10"><h1  class="martop">洞神三皇经</h1></router-link>
					 <ul><li v-for="item in listarr10" class="cateli"><router-link :to="'/daozang10'+'-'+item.id">{{item.title}}</router-link></li></ul>
				</br>
				<router-link to="/c11"><h1  class="martop">三洞经教</h1></router-link>
					 <ul><li v-for="item in listarr11" class="cateli"><router-link :to="'/daozang11'+'-'+item.id">{{item.title}}</router-link></li></ul>
				 <GoTop />
		</div>
		<div class="body-main" v-if="this.$route.params.id==='2'">		
		<router-link to="/c12"><h1  class="martop">太平部诸经</h1></router-link>
							<ul><li v-for="item in listarr12" class="cateli"><router-link :to="'/daozang12'+'-'+item.id">{{item.title}}</router-link></li></ul>
							</br>
								<router-link to="/c13"><h1  class="martop">太玄部经诀</h1></router-link>
							<ul><li v-for="item in listarr13" class="cateli"><router-link :to="'/daozang13'+'-'+item.id">{{item.title}}</router-link></li></ul>
							</br>
								<router-link to="/c14"><h1  class="martop">正一部经籙</h1></router-link>
							<ul><li v-for="item in listarr14" class="cateli"><router-link :to="'/daozang14'+'-'+item.id">{{item.title}}</router-link></li></ul>
							</br>
								<router-link to="/c15"><h1  class="martop">道德真经</h1></router-link>
							<ul><li v-for="item in listarr15" class="cateli"><router-link :to="'/daozang15'+'-'+item.id">{{item.title}}</router-link></li></ul>
							</br>
								<router-link to="/c16"><h1  class="martop">四子真经</h1></router-link>
							<ul><li v-for="item in listarr16" class="cateli"><router-link :to="'/daozang16'+'-'+item.id">{{item.title}}</router-link></li></ul>
							</br>
								<router-link to="/c17"><h1  class="martop">黄帝阴符经</h1></router-link>
							<ul><li v-for="item in listarr17" class="cateli"><router-link :to="'/daozang17'+'-'+item.id">{{item.title}}</router-link></li></ul>
							</br>
								<router-link to="/c18"><h1  class="martop">道教易学</h1></router-link>
							<ul><li v-for="item in listarr18" class="cateli"><router-link :to="'/daozang18'+'-'+item.id">{{item.title}}</router-link></li></ul>
							</br>
								<router-link to="/c19"><h1  class="martop">太清金丹经</h1></router-link>
							<ul><li v-for="item in listarr19" class="cateli"><router-link :to="'/daozang19'+'-'+item.id">{{item.title}}</router-link></li></ul>
							</br>
								<router-link to="/c20"><h1  class="martop">太清摄养经</h1></router-link>
		<ul><li v-for="item in listarr20" class="cateli"><router-link :to="'/daozang20'+'-'+item.id">{{item.title}}</router-link></li></ul>
		 <GoTop />
		</div>
		<div class="body-main" v-if="this.$route.params.id==='3'">
								<router-link to="/c21"><h1  class="martop">诸子文集</h1></router-link>
							<ul><li v-for="item in listarr21" class="cateli"><router-link :to="'/daozang21'+'-'+item.id">{{item.title}}</router-link></li></ul>
							</br>
								<router-link to="/c22"><h1  class="martop">道学论著</h1></router-link>
							<ul><li v-for="item in listarr22" class="cateli"><router-link :to="'/daozang22'+'-'+item.id">{{item.title}}</router-link></li></ul>
							</br>
								<router-link to="/c23"><h1  class="martop">全真文集</h1></router-link>
							<ul><li v-for="item in listarr23" class="cateli"><router-link :to="'/daozang23'+'-'+item.id">{{item.title}}</router-link></li></ul>
							</br>
								<router-link to="/c24"><h1  class="martop">道教类书</h1></router-link>
								<ul><li v-for="item in listarr24" class="cateli"><router-link :to="'/daozang24'+'-'+item.id">{{item.title}}</router-link></li></ul>
					 <GoTop />			
		
		</div>
		<div class="body-main" v-if="this.$route.params.id==='4'">
				<router-link to="/c25"><h1  class="martop">道法诸经</h1></router-link>
				<ul><li v-for="item in listarr25" class="cateli"><router-link :to="'/daozang25'+'-'+item.id">{{item.title}}</router-link></li></ul>
				</br>
				<router-link to="/c26"><h1  class="martop">道法总集</h1></router-link>
				<ul><li v-for="item in listarr26" class="cateli"><router-link :to="'/daozang26'+'-'+item.id">{{item.title}}</router-link></li></ul>
		
		 <GoTop />
		</div>
		<div class="body-main" v-if="this.$route.params.id==='5'">
			<router-link to="/c27"><h1  class="martop">科戒威仪</h1></router-link>
			<ul><li v-for="item in listarr27" class="cateli"><router-link :to="'/daozang27'+'-'+item.id">{{item.title}}</router-link></li></ul>
				</br>
				<router-link to="/c28"><h1  class="martop">灵宝诸斋仪</h1></router-link>
			<ul><li v-for="item in listarr28" class="cateli"><router-link :to="'/daozang28'+'-'+item.id">{{item.title}}</router-link></li></ul>
				</br>
				<router-link to="/c29"><h1  class="martop">灯仪法忏章表</h1></router-link>
		<ul><li v-for="item in listarr29" class="cateli"><router-link :to="'/daozang29'+'-'+item.id">{{item.title}}</router-link></li></ul>
		 <GoTop />
		</div>
		<div class="body-main" v-if="this.$route.params.id==='6'">
		<router-link to="/c30"><h1  class="martop">神仙高道传</h1></router-link>
	<ul><li v-for="item in listarr30" class="cateli"><router-link :to="'/daozang30'+'-'+item.id">{{item.title}}</router-link></li></ul>
			</br>
			<router-link to="/c31"><h1  class="martop">仙境名山志</h1></router-link>
		<ul><li v-for="item in listarr31" class="cateli"><router-link :to="'/daozang31'+'-'+item.id">{{item.title}}</router-link></li></ul>
		 <GoTop />
		</div>
		<div class="body-main" v-if="this.$route.params.id>7">
			<ol>
				<li v-for="item in listarr" class="cateli">
					<router-link :to="'/daozang'+cateid+'-'+item.id">{{item.title}}</router-link>
				</li>
			</ol>
			<GoTop />
		</div></br></br>
	</div>
</template>
<script>
	import Header from '@/components/Header.vue'
	import GoTop from '@/components/gotop.vue'
	import modal from '@/components/modal.vue'
	import axios from 'axios'
	export default {
		data() {
			return {
				catename: '',
				listarr: [],
				showModal: false,
				listcate: [],
				cateid:'',
				catenameid:'',
				listarr8: [],
				listarr9: [],
				listarr10: [],
				listarr11: [],
				listarr12: [],
				listarr13: [],
				listarr14: [],
				listarr15: [],
				listarr16: [],
				listarr17: [],
				listarr18: [],
				listarr19: [],
				listarr20: [],
				listarr21: [],
				listarr22: [],
				listarr23: [],
				listarr24: [],
				listarr25: [],
				listarr26: [],
				listarr27: [],
				listarr28: [],
				listarr29: [],
				listarr30: [],
				listarr31: [],
			}
		},
		props: ['navcataname'],
		components: {
			Header,
			GoTop,
			modal
		},

		mounted() {
			this.getlist(); 
			this.getcateid();
			this.getlist8(); 
			this.getlist9(); 
			this.getlist10(); 
						this.getlist11();
						this.getlist12();
						this.getlist13();
						this.getlist14();
						this.getlist15();
						this.getlist16();
						this.getlist17();
						this.getlist18();
						this.getlist19();
						this.getlist20();
						this.getlist21();
						this.getlist22();
						this.getlist23();
						this.getlist24();
						this.getlist25();
						this.getlist26();
						this.getlist27();
						this.getlist28();
						this.getlist29();
						this.getlist30();
						this.getlist31();



		},

		methods: {
			getcateid: function(){
				this.cateid = this.$route.params.id;
			},
 
			getlist: function() {
				var _self = this;
				 
				axios.get('https://m.daorenjia.com/api/apicate.php?id=' + this.$route.params.id).then(function(response) {
					 // console.log(response);
					 _self.catename = response.data.catename;
					if(_self.$route.params.id>7){
					_self.listarr = response.data.catedata;}else{
						//_self.listcate=response.data[0].tit1le;
						_self.listcate=response.data.catedata;
						//_self.catenameid = response.data.catedata.erjiid;
						
					}
				})
			},
			
			getlist8: function() {
				var _self8 = this; 
				axios.get('https://m.daorenjia.com/api/apicate.php?id=8').then(function(response) {
					// _self8.catename = response.data.catename;			
					_self8.listarr8 = response.data.catedata;
				})	 
			},
			getlist9: function() {
				var _self9 = this; 
				axios.get('https://m.daorenjia.com/api/apicate.php?id=9').then(function(response) {
					// _self9.catename = response.data.catename;			
					_self9.listarr9 = response.data.catedata;
				})	 
			},
			getlist10: function() {
				var _self10 = this; 
				axios.get('https://m.daorenjia.com/api/apicate.php?id=10').then(function(response) {
					// _self10.catename = response.data.catename;			
					_self10.listarr10 = response.data.catedata;
				})	 
			},
			getlist11: function() {
				var _self11 = this; 
				axios.get('https://m.daorenjia.com/api/apicate.php?id=11').then(function(response) {		
					_self11.listarr11 = response.data.catedata;
				})	 
			},
			getlist12: function() {
				var _self12 = this; 
				axios.get('https://m.daorenjia.com/api/apicate.php?id=12').then(function(response) {		
					_self12.listarr12 = response.data.catedata;
				})	 
			},
			getlist13: function() {
				var _self13 = this; 
				axios.get('https://m.daorenjia.com/api/apicate.php?id=13').then(function(response) {		
					_self13.listarr13 = response.data.catedata;
				})	 
			},
			getlist14: function() {
				var _self14 = this; 
				axios.get('https://m.daorenjia.com/api/apicate.php?id=14').then(function(response) {		
					_self14.listarr14 = response.data.catedata;
				})	 
			},
			getlist15: function() {
				var _self15 = this; 
				axios.get('https://m.daorenjia.com/api/apicate.php?id=15').then(function(response) {		
					_self15.listarr15 = response.data.catedata;
				})	 
			},
			getlist16: function() {
				var _self16 = this; 
				axios.get('https://m.daorenjia.com/api/apicate.php?id=16').then(function(response) {		
					_self16.listarr16 = response.data.catedata;
				})	 
			},
			getlist17: function() {
				var _self17 = this; 
				axios.get('https://m.daorenjia.com/api/apicate.php?id=17').then(function(response) {		
					_self17.listarr17 = response.data.catedata;
				})	 
			},
			getlist18: function() {
				var _self18 = this; 
				axios.get('https://m.daorenjia.com/api/apicate.php?id=18').then(function(response) {		
					_self18.listarr18 = response.data.catedata;
				})	 
			},
			getlist19: function() {
				var _self19 = this; 
				axios.get('https://m.daorenjia.com/api/apicate.php?id=19').then(function(response) {		
					_self19.listarr19 = response.data.catedata;
				})	 
			},
			getlist20: function() {
				var _self20 = this; 
				axios.get('https://m.daorenjia.com/api/apicate.php?id=20').then(function(response) {		
					_self20.listarr20 = response.data.catedata;
				})	 
			},
			getlist21: function() {
				var _self21 = this; 
				axios.get('https://m.daorenjia.com/api/apicate.php?id=21').then(function(response) {		
					_self21.listarr21 = response.data.catedata;
				})	 
			},
			getlist22: function() {
				var _self22 = this; 
				axios.get('https://m.daorenjia.com/api/apicate.php?id=22').then(function(response) {		
					_self22.listarr22 = response.data.catedata;
				})	 
			},
			getlist23: function() {
				var _self23 = this; 
				axios.get('https://m.daorenjia.com/api/apicate.php?id=23').then(function(response) {		
					_self23.listarr23 = response.data.catedata;
				})	 
			},
			getlist24: function() {
				var _self24 = this; 
				axios.get('https://m.daorenjia.com/api/apicate.php?id=24').then(function(response) {		
					_self24.listarr24 = response.data.catedata;
				})	 
			},
			getlist25: function() {
				var _self25 = this; 
				axios.get('https://m.daorenjia.com/api/apicate.php?id=25').then(function(response) {		
					_self25.listarr25 = response.data.catedata;
				})	 
			},
			getlist26: function() {
				var _self26 = this; 
				axios.get('https://m.daorenjia.com/api/apicate.php?id=26').then(function(response) {		
					_self26.listarr26 = response.data.catedata;
				})	 
			},
			getlist27: function() {
				var _self27 = this; 
				axios.get('https://m.daorenjia.com/api/apicate.php?id=27').then(function(response) {		
					_self27.listarr27 = response.data.catedata;
				})	 
			},
			getlist28: function() {
				var _self28 = this; 
				axios.get('https://m.daorenjia.com/api/apicate.php?id=28').then(function(response) {		
					_self28.listarr28 = response.data.catedata;
				})	 
			},
			getlist29: function() {
				var _self29 = this; 
				axios.get('https://m.daorenjia.com/api/apicate.php?id=29').then(function(response) {		
					_self29.listarr29 = response.data.catedata;
				})	 
			},
			getlist30: function() {
				var _self30 = this; 
				axios.get('https://m.daorenjia.com/api/apicate.php?id=30').then(function(response) {		
					_self30.listarr30 = response.data.catedata;
				})	 
			},
			getlist31: function() {
				var _self31 = this; 
				axios.get('https://m.daorenjia.com/api/apicate.php?id=31').then(function(response) {		
					_self31.listarr31 = response.data.catedata;
				})	 
			},			
			
			goBack() {
				window.history.length > 1 ?
					this.$router.go(-1) :
					this.$router.push('/')
			},

		},
	


	}
</script>
<style>
	.cateli {
		margin-top: 2.5vh;
		border-bottom: #808080 dotted 1px;
		width: 90vw;
		list-style-type: decimal;
		list-style-position: inside;
	}
	.catezongli {
		margin-top: 2vh;
		margin-left: 3vw;
	}
</style>
